import { render, staticRenderFns } from "./SentimentosFeedback.vue?vue&type=template&id=5ed8b7c9"
import script from "./SentimentosFeedback.vue?vue&type=script&lang=js"
export * from "./SentimentosFeedback.vue?vue&type=script&lang=js"
import style0 from "./SentimentosFeedback.vue?vue&type=style&index=0&id=5ed8b7c9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports